



























import Vue from 'vue'
import { Component, Emit } from 'vue-property-decorator'

@Component({})
export default class CaseTypeSelector extends Vue {
  active = 0

  show = false
  options = ['My Case', 'All Case']

  @Emit('select')
  onSelectChange (index: number) {
    this.active = index
    this.show = false
    return this.active
  }

  showList () {
    this.show = true
  }

  hideList () {
    this.show = false
  }
}
